import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "auth_service",
  "use": "auth_service-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"auth_service\"><g fill-rule=\"evenodd\"><path d=\"M14 0v11.535l-.446.297-6 3.798L7 16l-.556-.37-5.998-3.798L0 11.535V0h14zm-1 3H1v8l6 3.798L13 11V3z\" /><path d=\"M10.429 6.286l-.857-.515L7 10.057 4.429 5.77l-.857.515L7 12z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id